import { Component, EventEmitter, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MbButtonComponent } from '../mb-button/mb-button.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-mb-success-modal',
  standalone: true,
  imports: [MbButtonComponent, NzModalModule, TranslocoDirective],
  templateUrl: './mb-success-modal.component.html',
  styleUrls: ['./mb-success-modal.component.css'],
})
export class MbSuccessModalComponent implements OnChanges, OnDestroy {
  @Input() isVisible = false;
  @Input() message = 'Successfully completed request!';
  @Input() duration = 3000;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  private timer?: ReturnType<typeof setTimeout>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible']?.currentValue === true) {
      this.startAutoClose();
    }
    if (changes['isVisible']?.currentValue === false) {
      this.clearTimer();
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private startAutoClose(): void {
    this.clearTimer(); // prevent overlap
    this.timer = setTimeout(() => this.closeSuccessModal(), this.duration);
  }

  private clearTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }

  closeSuccessModal(): void {
    this.clearTimer();
    if (this.isVisible) {
      this.isVisible = false;
      this.isVisibleChange.emit(false);
    }
  }
}
